/* CDS Gift Wrap — Emballage cadeau panier (cart natif + drawer)
   Chargé une fois via theme.liquid. Utilise l'event delegation sur
   `document` pour fonctionner même quand le drawer est re-rendu en AJAX. */
(function() {
  if (window.__cdsGiftWrapInit) return;
  window.__cdsGiftWrapInit = true;

  function dispatchCartUpdate(pid, qty) {
    var e = new Event('cart:update', { bubbles: true });
    e.detail = { resource: {}, sourceId: 'cds-gift-wrap', data: { source: 'cds-gift-wrap', productId: pid, itemCount: qty, sections: {} } };
    document.dispatchEvent(e);
  }

  function updateCartCount() {
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(c) {
      document.querySelectorAll('.cart-count,[data-cart-count],.cds-hg__badge').forEach(function(el) {
        el.textContent = c.item_count;
      });
    }).catch(function() {});
  }

  function addGiftWrap(wrap, variantId) {
    var label = wrap.querySelector('.cds-gift-wrap__label');
    if (label) label.classList.add('is-loading');
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
    .then(function(r) {
      if (!r.ok) return r.json().then(function(err) { throw err; });
      return r.json();
    });
  }

  function removeGiftWrap(wrap, lineKey) {
    var label = wrap.querySelector('.cds-gift-wrap__label');
    if (label) label.classList.add('is-loading');
    if (!lineKey) {
      // No line key known: try by variant id via /cart/update.js
      var variantId = wrap.getAttribute('data-variant-id');
      var body = { updates: {} };
      body.updates[variantId] = 0;
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function(r) { return r.json(); });
    }
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    }).then(function(r) { return r.json(); });
  }

  function handleGiftWrapChange(input) {
    var wrap = input.closest('[data-cds-gift-wrap]');
    if (!wrap) return;
    var variantId = wrap.getAttribute('data-variant-id');
    var lineKey = wrap.getAttribute('data-line-key');
    var promise;
    if (input.checked) {
      promise = addGiftWrap(wrap, variantId);
    } else {
      promise = removeGiftWrap(wrap, lineKey);
    }
    promise
      .then(function() {
        updateCartCount();
        dispatchCartUpdate(wrap.getAttribute('data-product-id'), input.checked ? 1 : 0);
      })
      .catch(function(err) {
        // Rollback UI
        input.checked = !input.checked;
        console.error('[cds-gift-wrap] cart op failed', err);
        var label = wrap.querySelector('.cds-gift-wrap__label');
        if (label) label.classList.remove('is-loading');
      });
  }

  // Event delegation on document — works for initial render AND AJAX re-renders
  document.addEventListener('change', function(e) {
    var target = e.target;
    if (target && target.matches && target.matches('[data-cds-gift-wrap-input]')) {
      handleGiftWrapChange(target);
    }
  });
})();
